import { BeneficiaryDetails } from './reference-book-payment-details.types';

export const fields: Array<keyof BeneficiaryDetails> = [
    'departmentCode',
    'beneficiaryCode',
    'beneficiaryName',
    'region',
];
